import { PageAttr } from "../../../../shared/domain/entities/fetch-entities";
import { useConcatPages } from "../../../../shared/infrastructure";
import { useFetch } from "../../../../public/auth/infrastructure/store/fetch-context";
import { EquipmentTypeT, UseGetEquipmentTypesFilters } from "../../domain";
import {
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

const equipmentTypeKeys = {
  all: ["equipmentTypes"] as const,
  equipmentTypes: () =>
    [...equipmentTypeKeys.all, "equipmentTypes-list"] as const,
  equipmentTypesList: (filters: UseGetEquipmentTypesFilters) =>
    [...equipmentTypeKeys.equipmentTypes(), filters] as const,
};

const EQUIPMENT_TYPES_ENDPOINT = "equipment-types";

const useInfiniteGetEquipmentTypes = (
  filters: UseGetEquipmentTypesFilters,
  config: UseInfiniteQueryOptions<PageAttr<EquipmentTypeT>> = {}
): UseInfiniteQueryResult<PageAttr<EquipmentTypeT>> & {
  allPages: PageAttr<EquipmentTypeT>["data"];
} => {
  const fetch = useFetch();

  const response = useInfiniteQuery<PageAttr<EquipmentTypeT>>(
    equipmentTypeKeys.equipmentTypesList(filters),
    async ({ pageParam: page = 1 }: { pageParam?: number }) => {
      const response = await fetch.get<PageAttr<EquipmentTypeT>>(
        EQUIPMENT_TYPES_ENDPOINT,
        {
          params: {
            page,
            limit: 10,
            ...filters,
          },
        }
      );

      return response.data;
    },
    {
      ...config,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.data.length > 0 ? allPages.length + 1 : undefined,
    }
  );

  const allPages = useConcatPages(response.data?.pages ?? []);

  return {
    ...response,
    allPages,
  };
};

export { equipmentTypeKeys, useInfiniteGetEquipmentTypes };
